import Vue from "vue";
import VueMask from "v-mask";
Vue.use(VueMask);

/*

* documentação:
* https://github.com/probil/v-mask/tree/master

*/